import { PROGRAMME, COL_PROGRAMME } from "./field/programme";

const getSearchFields = () => {

  return [
    PROGRAMME,
  ];

}

const getSearchFormConfig = ({ search_type }) => {

  const MOBILE_FORM = [
    {
      id: "row_1",
      type: "row",
      props: {
        className: "gy-2 d-flex flex-fill"
      },
      children: [
        {
          id: "col",
          type: "col",
          props: {
            className: "",
          },
          children: [
            PROGRAMME,
          ]
        },
      ]
    }
  ];

  const DESKTOP_FORM = [
    {
      id: "row_1",
      type: "row",
      props: {
        className: "gy-2 d-flex flex-fill"
      },
      children: [
        COL_PROGRAMME,
      ]
    }
  ];

  const MOBILE = {
    id: "mobile",
    type: "div",
    props: {
      className: "d-flex flex-column d-sm-none mobile"
    },
    children: MOBILE_FORM
  };

  const DESKTOP = {
    id: "desktop",
    type: "div",
    props: {
      className: "d-none d-sm-flex flex-column desktop"
    },
    children: DESKTOP_FORM
  };

  // TODO: Hook here

  if (search_type === "map") {
    return MOBILE_FORM;
  }

  return [{
    id: "form",
    type: "div",
    children: [
      MOBILE,
      DESKTOP
    ]
  }];

}

export { getSearchFields, getSearchFormConfig };
